module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-header', {
    staticClass: "xheadBgc",
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "left-options": {
        backText: "我的"
      }
    }
  }, [_c('router-link', {
    staticClass: "Main_left",
    attrs: {
      "slot": "overwrite-left",
      "to": "/main"
    },
    slot: "overwrite-left"
  }, [_vm._v("我的")]), _vm._v("\n\t\t\t账户管理\n\t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "user-safety-info"
  }, [_c('div', {
    staticClass: "user-safety-user"
  }, [_c('div', {
    staticClass: "user-avatar"
  }, [_c('p', {
    staticClass: "user-name-box"
  }, [_vm._v("欢迎，" + _vm._s(_vm.userTile))])])])]), _vm._v(" "), _c('group', {
    staticClass: "detailsInfo"
  }, [_c('x-input', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "title": "实名认证",
      "text-align": "left",
      "disabled": ""
    },
    model: {
      value: (_vm.CertState),
      callback: function($$v) {
        _vm.CertState = $$v
      },
      expression: "CertState"
    }
  }, [(_vm.userInfo.cert_state != '审核成功') ? _c('span', {
    staticClass: "no_user",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }) : _vm._e(), _vm._v(" "), (_vm.userInfo.cert_state === '审核成功') ? _c('span', {
    staticClass: "identity-yes",
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }) : _vm._e()]), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "绑定手机",
      "text-align": "left",
      "disabled": ""
    },
    model: {
      value: (_vm.userInfo.ID_Mobile),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "ID_Mobile", $$v)
      },
      expression: "userInfo.ID_Mobile"
    }
  }), _vm._v(" "), _c('x-input', {
    attrs: {
      "title": "绑定邮箱",
      "text-align": "left",
      "disabled": ""
    },
    model: {
      value: (_vm.userInfo.ID_Email),
      callback: function($$v) {
        _vm.$set(_vm.userInfo, "ID_Email", $$v)
      },
      expression: "userInfo.ID_Email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "exitBtn"
  }, [_c('span', {
    on: {
      "click": _vm.loginOut
    }
  }, [_vm._v("退出登录")])]), _vm._v(" "), _c('toast', {
    staticClass: "zjwToast",
    attrs: {
      "type": _vm.tipType,
      "width": "4.5rem",
      "text": _vm.tiptxt,
      "time": 1800,
      "is-show-mask": "",
      "position": _vm.position
    },
    model: {
      value: (_vm.showPositionValue),
      callback: function($$v) {
        _vm.showPositionValue = $$v
      },
      expression: "showPositionValue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f87919c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/safety.vue
// module id = iFxj
// module chunks = 1